import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _6FtApartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"6_ft_apart"}/>
}
